<template>
  <div>
    <div class="container" style="text-align: center; padding-top: 6rem">
      <div>
        <i
          class="fa fa-check-circle"
          style="color: darkgreen; font-size: 10rem"
        ></i>

        <h1 style="margin-top: 4rem; font-weight: 300">
          Děkujeme za Vaší objednávku
        </h1>
        <p style="padding-top: 2rem">
          Vaše objednávka číslo #{{ $store.state.order.id }} byla přijata. Další
          informace Vám byly odeslány emailem na adresu
          {{ $store.state.order.email }}.
        </p>
        <div v-if="$store.state.order.payment === 'BANK_TRANSFER'">
          <h3 style="padding-top: 3rem">Údaje pro platbu převodem</h3>
          <p>Pro zjednodušení Vaší platby použijte QR kód.</p>
          <div class="row">
            <div class="col-sm-6" style="display: grid">
              <table style="float: right; text-align: right">
                <tr>
                  <td>Bankovní účet</td>
                  <td>2601824856/2010</td>
                </tr>
                <tr>
                  <td>Konstantní symbol</td>
                  <td>0079</td>
                </tr>
                <tr>
                  <td>Variabliní symbol</td>
                  <td>{{ $store.state.order.id }}</td>
                </tr>
                <tr>
                  <td>Částka</td>
                  <td>{{ $store.state.order.totalWithVat }} Kč</td>
                </tr>
              </table>
            </div>

            <div class="col-sm-6">
              <qr-code
                :text="$store.state.order.spaydPayment"
                class="qr-code"
                style="float: left"
              ></qr-code>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Thanks",
  data: function () {
    return {
      order: { cartItems: [] },
    };
  },
  created() {
    if (!this.$store.state.order.id) {
      this.$router.push("/");
    }
  },

  methods: {},
};
</script>